import React from "react";
import icon from "../../../asset/trophy-svgrepo-com.svg";
import CrownLottie from "../../component/CrownLottie";

const LeaderboardTopTraderDesktop = ({  profile_pics, username, points }) => {
  return (
    <div className="leaderboard__list__section">
      <div className="leaderboard__list__section__image">
        <img src={profile_pics} alt="" className="leaderboard__list__section__img" />
        <div className="leaderboard__crown__span"><CrownLottie/></div>
      </div>
      <div className="leaderboard__list__section__text">
        <p className="leaderboard__list__section__first__text">{username}</p>
        <div className="leaderboard__list__section__section">
          <p className="leaderboard__list__section__second__text">{`${points} pts`}</p>
          <div className="avatar__list__section__section__image">
            <img src={icon} alt="" className="avatar__list__section__section__img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardTopTraderDesktop;